import { inject, watch } from 'vue'

import type { InjectionKey } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const POPUP_TOGGLE_KEY: InjectionKey<() => boolean> = Symbol()

export function onPopupReopen(callback: () => void) {
  const popupToggleStatus = inject(POPUP_TOGGLE_KEY, null)

  if (popupToggleStatus) {
    watch(popupToggleStatus, (show) => {
      if (show) {
        callback()
      }
    })
  }
}
